<template>
    <div class="max-w-full overflow-x-hidden">
        <NavBar />
        <div>
            <slot />
        </div>
        <Footer/>
    </div>
</template>
